import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { QuoteCodeService } from 'app/services/models/quote-code.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-customer-confirm-mail-send-dialog',
  templateUrl: './customer-confirm-mail-send-dialog.component.html',
  styleUrls: ['./customer-confirm-mail-send-dialog.component.scss']
})
export class CustomerConfirmMailSendDialogComponent implements OnInit {
  @Input() data: { transactionManagementId: number; email?: string };
  customerConfimrMailForm: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    private quoteCode: QuoteCodeService
  ) { }

  ngOnInit() {
    this.customerConfimrMailForm = this.fb.group({
      transactionManagementId: [this.data.transactionManagementId, Validators.required],
      email: [this.data.email, Validators.required],
    });
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async sendEmail() {
    if (this.customerConfimrMailForm.valid) {
      const formData = this.customerConfimrMailForm.value;
      // Buraya API çağrısı veya event emit işlemi eklenebilir
      console.log('Form verisi:', formData);
      const response = await this.quoteCode.updateQuoteCode(formData.transactionManagementId, formData.email);
      if (response.status == true) {
        this.toastrService.success(response.message);
        this.activeModal.close(true);
      }
      else {
        this.toastrService.error(response.message);
      }
    } else {
      this.toastrService.error('Lütfen geçerli bir mail adresi giriniz');
    }
  }

}
